export const ROUTES = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  SYSTEM_EVENTS: '/system-events',
  DASHBOARD: '/dashboard',
  NOTIFICATIONS: '/notifications',
  USER_DASHBOARD: '/my-dashboard',
  OPTIMIZE_REPORT: '/reports/optimize-countermeasure',
  ONBOARDING: '/onboarding',
  INTAKE: '/intake',
  REDIRECT_OPTIONS: '/redirect_options',
  PVT: '/pvt',
  SLEEP: '/sleep',
  CAFFEINE: '/caffeine',
  SCHEDULE_IMPORT: '/schedule-imports',
  USER_IMPORT: '/user-imports',
  ACCOUNT_CONFIG: '/account-config',
  INTAKE_LIST: '/intake/list',
  PREDICTION_HISTORY: '/reports/prediction-history',
  SHIFT_FATIGUE: '/reports/shift-fatigue',
  PREDICTION: '/reports/prediction',
  FATIGUE_EVOLUTION: '/reports/fatigue-evolution',
  SLEEP_QUANTITY: '/reports/sleep-quantity',
  FATIGUE_DISTRIBUTION: '/reports/fatigue-distribution',
  REPORT_USER_DATA_QUALITY: '/reports/user-data-quality',
  ADMIN_COCKPIT: '/admin-cockpit',
  USER_FULL_LIST: '/user-full-list',
  DATA_EXPORT: '/data-export',
  SHIFT_LIST: '/shift-list',
  INTERVENTIONS: '/interventions',
  ACCOUNT_CHANGE: '/account-change',
}
